import { render, staticRenderFns } from "./ReferAFriend.vue?vue&type=template&id=40d12148&scoped=true&"
import script from "./ReferAFriend.vue?vue&type=script&lang=js&"
export * from "./ReferAFriend.vue?vue&type=script&lang=js&"
import style0 from "./ReferAFriend.vue?vue&type=style&index=0&id=40d12148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d12148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
